import PropTypes from "prop-types"
import Switch from "shared/components/switch"

export default function PushNotification({ value, onChange }) {
  return (
    <div className="push-notifications">
      <span className="push-notifications-message">
        Receive notifications when this Applet runs
      </span>
      <div>
        <Switch
          backgroundColor="rgba(0, 0, 0, 0.0)"
          circleColor={"white"}
          circleColorEnabled={"white"}
          backgroundColorEnabled={"#70d600"}
          onChange={onChange}
          value={value}
        />
      </div>
    </div>
  )
}

PushNotification.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
}
